export const chartColours = ['#F2AE21', '#5ABBE5', '#92C15F', '#12ACA2', '#D9D44F', '#EA516D', '#ED7723', '#B8B132'];
export const sexColours = {
  female: '#EA516D',
  male: '#5ABBE5',
};
